export const SPORTS = [
    {
        key: "badminton",
        label: "Badminton",
        color: "#00f5a0",
        emoji: "🏸",
    },
    {
        key: "cricket",
        label: "Cricket",
        color: "#00d9f5",
        emoji: "🏏",
    },
];